import axios from 'axios';

const api = axios.create({
    baseURL: 'https://filial-roja-api-94c18da96b56.herokuapp.com',
});

export default api;